import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { resultCardStyles } from 'marketplace-ui-common/storefront/utils/resultCardStyles';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import Carousel from 'marketplace-ui-common/components/Carousel';
import CollectionCard from 'marketplace-ui-common/collections/components/CollectionCard'; // @ts-expect-error untyped dependency

import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper'; // @ts-expect-error untyped dependency

import { getAppStorefrontRoute } from '../../utils/urls';
import { usePublishedAppCollections } from '../hooks/usePublishedAppCollections';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
const StyledCollectionCard = styled(CollectionCard).withConfig({
  displayName: "AppCollectionsCardGrid__StyledCollectionCard",
  componentId: "dgzx9n-0"
})(["", ""], resultCardStyles);
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "AppCollectionsCardGrid__StyledRouterLink",
  componentId: "dgzx9n-1"
})(["display:flex;align-items:stretch;"]);
export default function AppCollectionsCardGrid() {
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const {
    maxCardsPerPage
  } = useResponsiveProps({
    maxCardsPerPage: {
      [ScreenSizes.SM]: 1,
      [ScreenSizes.LG]: 2,
      [ScreenSizes.XL]: 3
    }
  });
  const {
    getDisplayedCollections,
    requestState: publishedAppCollectionsRequestState
  } = usePublishedAppCollections();
  const displayedCollections = getDisplayedCollections();
  const collectionCards = useMemo(() => displayedCollections.map((collection, index) => collection.publishedListing && /*#__PURE__*/_jsx(StyledRouterLink, {
    onClick: () => trackInteraction('click collection', {
      value: collection.publishedListing.slug,
      itemIndex: index
    }),
    style: {
      height: '100%'
    },
    to: getAppStorefrontRoute(collection.publishedListing.slug),
    use: "unstyled",
    children: /*#__PURE__*/_jsx(StyledCollectionCard, {
      collection: collection,
      descriptionI18nKey: `appMarketplace.collections.collection_${collection.id}.description`,
      titleI18nKey: `appMarketplace.collections.collection_${collection.id}.name`
    })
  }, `collection-${collection.id}`)), [displayedCollections, trackInteraction]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: publishedAppCollectionsRequestState,
    children: /*#__PURE__*/_jsx(Carousel, {
      className: "p-x-0",
      cards: collectionCards,
      maxCardsPerPage: maxCardsPerPage
    })
  });
}